module.exports = __webpack_public_path__ + "static/media/tensorflow.1727b586.png";